<template>
  <div>
    <div class="tns-controls">
      <button
        class="slider--prev"
        aria-label="předchozí"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="var(--soslp-blue-dark)" d="M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"/></svg>
      </button>
      <button
        class="slider--next"
        aria-label="následující"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="var(--soslp-blue-dark)" d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"/></svg>
      </button>
    </div>
    <div class="slider--slides">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { tns } from 'tiny-slider'

export default {
  name: 'VWhatsHappeningSlider',
  mounted () {
    this.$nextTick(() => {
      const slider = tns({
        container: ".slider--slides",
        slideBy: 1,
        autoplay: true,
        gutter: 30,
        edgePadding: 0,
        controlsContainer: '.tns-controls',
        prevButton: '.slider--prev',
        nextButton: '.slider--next',
        responsive: {
          0: {
            items: 1
          },
          550: {
            items: 2
          }
        },
        autoplayButton: false,
        autoplayText: [],
        autoplayButtonOutput: false,
        nav: true,
        arrowKeys: true,
        controls: true,
        controlsPosition: 'bottom',
      })
    })
  }
}
</script>
